import gql from 'graphql-tag';

export class SubscriptionQueries {
  static load = gql`
    query Subscription {
      subscription {
        id
        externalId
        entityId
        planCode
        status
        startDate
        expirationDate
        frequency
        currency
        seatQuantity {
          dealRoom
          suite
          contract
        }
        seatCount {
          dealroomAccess
          contractroomAccess
          suiteAccess
        }
        features {
          id
          name
          active
          type
          quantitySettings {
            maxQuantity
            unlimited
          }
        }
      }
    }
  `;

  static estimateExistingSubscription = gql`
    query EstimateExistingSubscription(
      $newDealroomSeats: Float
      $newContractSeats: Float
      $newSuiteSeats: Float
      $subscriptionId: String!
    ) {
      estimateExistingSubscription(
        newDealroomSeats: $newDealroomSeats
        newContractSeats: $newContractSeats
        newSuiteSeats: $newSuiteSeats
        subscriptionId: $subscriptionId
      ) {
        total
        amountDue
        lineItems {
          total
          unitPrice
          quantity
          seatType
        }
        nextBillingDate
      }
    }
  `;
}
